(() => {
  const fields = [
    ['input#pc--browser-opt-out-checkbox', 'Opt out of data sharing for this browser'],
    ['textarea[name="g-recaptcha-response"]', 'reCAPTCHA response'],
    ['textarea[name="h-captcha-response"]', 'hCaptcha response'],
  ];
  const labelFields = (root) => {
    for (const [selector, name] of fields) {
      const nodes = [...root.querySelectorAll(selector)];
      if (root.matches?.(selector)) nodes.unshift(root);
      for (const field of nodes) {
        // Keep any names provided by the privacy/CAPTCHA application.
        if (field.hasAttribute('aria-label') || field.hasAttribute('aria-labelledby') || field.labels?.length) continue;
        field.setAttribute('aria-label', name);
      }
    }
  };
  labelFields(document);
  // The privacy application can insert its CAPTCHA fields after initial load.
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) labelFields(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
